import { AfterViewInit, Component, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CatSelectionComponent } from './cat-selection/cat-selection.component';
import { AddGenericStreamComponent } from './add-generic-stream/add-generic-stream.component';
import { Router } from '@angular/router';
import { GenericStream } from '../../../lib/interfaces/generic-streams';
import { GenericStreamsService } from '../../../service/generic-streams.service';

@Component({
    selector: 'app-new-tracks',
    standalone: false,
    templateUrl: './new-tracks.component.html',
    styleUrl: './new-tracks.component.scss'
})
export class NewTracksComponent implements AfterViewInit {
    dialog = inject(MatDialog);
    router = inject(Router);
    genStreamService = inject(GenericStreamsService);

    showSearch: boolean = false;
    isLoading: boolean = false;
    searchString: string = "";
    streamsList: GenericStream[] = [];
    rawStreamsList: GenericStream[] = [];

    async ngAfterViewInit(): Promise<void> {
        let s = await this.genStreamService.getGenericStreams();
        if (s === false) return;


        this.streamsList = await Promise.all(
            s.map(async (_s: any) => {
            if(!_s.globalStream) {
                let c = await this.genStreamService.getCompaniesForPrivateGenericStream(_s.id);
                return {..._s, companies: c}
            } else {
                return _s;
            }
        }))

        this.rawStreamsList = this.streamsList;
    }

    search() {
        if (this.searchString === "") {
            this.streamsList = [...this.rawStreamsList]
            return;
        }
        this.streamsList = this.rawStreamsList.filter(stream => stream.name.toLowerCase().includes(this.searchString.toLowerCase()));
    }
    async updateAgents() {
        this.isLoading = true;
        let r = await this.genStreamService.triggerAgentUpdate();
        this.isLoading = false;
    }
    async deleteStream(id: string | undefined | null) {
        if (!id) return;
        let c = await confirm("Are you sure you want to delete this stream?");
        if (!c) return;
        let r = await this.genStreamService.deleteGenericStream(id);
        if (r === false) return;

        this.streamsList = this.streamsList.filter(stream => stream.id !== id);
    }

    editStream(id: string) {
        this.router.navigate(['home', 'generic-streams', id]);
    }

    async duplicateStream(id: string) {
        if(!id) return;

        let result = await this.genStreamService.duplicateGenericStream(id);

        if (result && typeof result === 'string') {
                this.router.navigate(['home', 'generic-streams', result]);
        }
    }

    async openTrackCatSelection() {
        let dia = await this.dialog.open(AddGenericStreamComponent, {
            panelClass: "wide-dialog",
            autoFocus: false
        });

        dia.afterClosed().subscribe(result => {
            if (result && typeof result === 'string') {
                this.router.navigate(['home', 'generic-streams', result]);
            }
        });
    }


}
